import angular from "angular";
import controller from "./complete-setup.controller";
import template from "./complete-setup.html";

function InstructorCompleteSetupDirective() {
  return {
    restrict: "E",
    scope: {
      instructor: "=",
      title: "=",
    },
    template: template,
    link: (scope, element, attrs) => {},
    controller: controller,
    controllerAs: "vm",
    bindToController: true,
  };
}

export default angular
  .module("instructor.directives.completesetup", [])
  .directive("instructorCompleteSetup", InstructorCompleteSetupDirective)
  .controller("InstructorCompleteSetupController", controller);
